const faqItems = [
  {
    q: '迷妹漫画网上的漫画都是免费看的吗？',
    a: '是的，迷妹漫画网聚合的所有漫画全集和完结漫画完整版均为免费在线阅读，无需付费订阅即可畅享全部完结漫画大全资源。',
  },
  {
    q: '什么是下拉式漫画阅读？',
    a: '下拉式漫画阅读是迷妹漫画网的核心阅读方式，所有漫画内容在一个页面内纵向排列，读者只需向下滚动即可连续阅读，无需翻页点击，体验如同刷社交媒体般流畅自然。',
  },
  {
    q: '网站上的漫画都是完结的吗？',
    a: '迷妹漫画网专注聚合已完结的漫画全集资源，我们推荐和展示的漫画均已完成连载，读者可以一次性从第一话读到大结局，不用担心等更新或断更。',
  },
  {
    q: '手机可以看迷妹漫画吗？',
    a: '完全支持！迷妹漫画网针对移动端进行了专门优化，用手机浏览器打开即可享受竖屏下拉式滚动漫画阅读，无需下载任何 App。',
  },
  {
    q: '站内漫画多久更新一次推荐榜单？',
    a: '迷妹漫画的完结漫画推荐榜单每日更新，我们会根据热度、口碑和新完结作品持续扩充和调整推荐内容，确保你每次访问都能发现值得补的完结漫画大全。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于迷妹漫画和完结漫画阅读的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/70">
          {faqItems.map((item, i) => (
            <div key={i} className="py-5 md:py-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-lg mt-0.5 shrink-0">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 pl-8 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}